import {confirmAlert} from "react-confirm-alert";
import React from "react";
import CloseProjectDialog from "../../../components/CloseProjectDialog";

const bodyStyle = {
    margin: "1.5rem"
}

const CloseProjectConfirmDialogBody = () => (
    <div style={bodyStyle}>
        <div>No additional updates can be made after the project is Closed.</div>
    </div>
);

const ShowCloseProjectConfirmDialog = (props, validationMsg) => {

    const options = {
        closeOnEscape: true,
        customUI: ({ onClose }) => <CloseProjectDialog
            onClose={ onClose }
            onAccept={ () => {
                props.handleCloseProject(props);
                onClose();
            }}
            body={<div><ul>{validationMsg}</ul> <CloseProjectConfirmDialogBody/></div> }
        />
    };
    confirmAlert(options);
};


export default ShowCloseProjectConfirmDialog;